/**
 * @generated SignedSource<<4fa421e2f03027ff1fca313175090780>>
 * @relayHash fb95a2cbe86b2f0f0b7b518a8b288e6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 976d2436db8be110888a6501a95eb3700812925cd33a499537180ab666e355cc

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFieldSchemeAssociatedFieldsInput = {
  nameOrDescriptionFilter?: string | null | undefined;
  schemeId: string;
};
export type FieldSchemePageQuery$variables = {
  cloudId: string;
  fieldSchemeAri: string;
  input: JiraFieldSchemeAssociatedFieldsInput;
};
export type FieldSchemePageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AssociatedFieldsTable" | "PageHeader">;
};
export type FieldSchemePageQuery = {
  response: FieldSchemePageQuery$data;
  variables: FieldSchemePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSchemeAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "kind": "Variable",
  "name": "input",
  "variableName": "input"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 40
  },
  (v3/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FieldSchemePageQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "AssociatedFieldsTable"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "fieldSchemeAri",
            "variableName": "fieldSchemeAri"
          }
        ],
        "kind": "FragmentSpread",
        "name": "PageHeader"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "FieldSchemePageQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraFieldSchemeAssociatedFieldsConnection",
        "kind": "LinkedField",
        "name": "jira_fieldSchemeAssociatedFields",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraFieldSchemeAssociatedFieldsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraFieldSchemeAssociatedField",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraField",
                    "kind": "LinkedField",
                    "name": "field",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "typeName"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isFieldLocked"
                  },
                  (v5/*: any*/),
                  (v7/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "filters": [
          "cloudId",
          "input"
        ],
        "handle": "connection",
        "key": "associatedFieldsTable_adminPagesFieldScheme_jira_fieldSchemeAssociatedFields",
        "kind": "LinkedHandle",
        "name": "jira_fieldSchemeAssociatedFields"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "fieldSchemeAri"
          }
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "schemeId"
              },
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "name": "projectsCount"
              }
            ],
            "type": "JiraFieldScheme"
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "976d2436db8be110888a6501a95eb3700812925cd33a499537180ab666e355cc",
    "metadata": {},
    "name": "FieldSchemePageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "135c3fa6cf49b6287a65de35ab3be2d5";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
